import { render, staticRenderFns } from "./FormPutaway.vue?vue&type=template&id=fbf318ce"
import script from "./FormPutaway.vue?vue&type=script&lang=js"
export * from "./FormPutaway.vue?vue&type=script&lang=js"
import style0 from "./FormPutaway.vue?vue&type=style&index=0&id=fbf318ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports